import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import './index.css';

import FileManager from './FileManager';
import ImageViewer from './ImageViewer';
import Login from './Login';

const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <React.StrictMode>
    <Toaster richColors position="bottom-right" />
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={
          <div className="page-center">
            <FileManager />
          </div>
        } />
        <Route path="/gallery/*" element={<div className='page-center'><ImageViewer /></div>} />
      </Routes>
    </Router>
  </React.StrictMode>
);
